import { ButtonGroup } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AppsIcon from "@material-ui/icons/Apps";
import ListIcon from "@material-ui/icons/List";
import * as React from "react";
import { cloneElement } from "react";
import { sanitizeListRestProps, TopToolbar, useListContext } from "react-admin";

const Actions = ({ selected, onSelect, ...props }) => {
	const { className, exporter, filters, maxResults, ...rest } = props;
	const {
		resource,
		displayedFilters,
		filterValues,
		showFilter,
	} = useListContext();
	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{filters &&
				cloneElement(filters, {
					resource,
					showFilter,
					displayedFilters,
					filterValues,
					context: "button",
				})}
			<ButtonGroup
				variant="contained"
				color="secondary"
				size="small"
				aria-label="list type"
			>
				<Button
					onClick={() => onSelect("grid")}
					variant={selected === "grid" ? "contained" : "outlined"}
				>
					<AppsIcon />
				</Button>
				<Button
					onClick={() => onSelect("list")}
					variant={selected === "list" ? "contained" : "outlined"}
				>
					<ListIcon />
				</Button>
			</ButtonGroup>
		</TopToolbar>
	);
};

export default Actions;
